import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=8df1cfb6&scoped=true&"
import script from "./Main.vue?vue&type=script&lang=js&"
export * from "./Main.vue?vue&type=script&lang=js&"
import style1 from "./Main.vue?vue&type=style&index=1&lang=css&"
import style2 from "./Main.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df1cfb6",
  null
  
)

export default component.exports